import { Route, Routes } from "react-router";

import LinkerPage from "../components/Linker/LinkerPage";

const Lenker = () => (
  <Routes>
    <Route index element={<LinkerPage />} />
  </Routes>
);

export default Lenker;
